import React from 'react';
import Icon from '../../../components/AppIcon';

const TermsSection = ({ section, isActive }) => {
  return (
    <section 
      id={section?.id}
      className={`scroll-mt-24 transition-all duration-300 ${
        isActive ? 'bg-primary/5 -mx-4 px-4 py-6 rounded-xl' : 'py-6'
      }`}
    >
      <div className="flex items-start space-x-3 mb-4">
        <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
          <Icon name={section?.icon} size={16} className="text-primary" />
        </div>
        <div className="flex-1">
          <h2 className="font-jakarta font-bold text-2xl text-text-primary mb-2">
            {section?.title}
          </h2>
          {section?.summary && (
            <div className="bg-surface rounded-lg p-4 mb-4 border-l-4 border-primary">
              <p className="text-sm font-inter text-text-secondary">
                <strong className="text-text-primary">Plain English:</strong> {section?.summary}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="prose prose-slate max-w-none">
        <div className="space-y-4 font-inter text-text-primary leading-relaxed">
          {section?.content?.map((paragraph, index) => (
            <div key={index}>
              {paragraph?.type === 'paragraph' && (
                <p className="text-base">{paragraph?.text}</p>
              )}
              {paragraph?.type === 'list' && (
                <ul className="list-disc list-inside space-y-2 ml-4">
                  {paragraph?.items?.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-base">{item}</li>
                  ))}
                </ul>
              )}
              {paragraph?.type === 'subsection' && (
                <div className="mt-6 mb-4">
                  <h3 className="font-jakarta font-semibold text-xl text-text-primary mb-3">
                    {paragraph?.title}
                  </h3>
                  <p className="text-base">{paragraph?.text}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TermsSection;